/*
    此文件为数据接口存放命名，为防止接口太多，造成接口混乱
    命名为大写斜杠
    按页面划分
    例如： 'ORDER_API': '/api/order',
    每个接口注释用途，为方面其他开发人员查找，了解。
    export default {

    } 
*/
export default {
  /**获取列表 */
  GET_ALL_DICT: '/maindata/dict/getAllDict',
  /**获取列表 */
  DICT_LIST_API: '/maindata/dict/listDict',
  /**添加字典 */
  ADD_DICT_API: '/maindata/dict/insertDict',
  /**字典详情 */
  GET_DICT_API: '/maindata/dict/getDictDetail',
  /**编辑字典 */
  UPDATE_DICT_API: '/maindata/dict/updateDict',
  /**删除字典 */
  DELETE_DICT_API: '/maindata/dict/deleteDict',
  /**获取字典数据列表 */
  DICT_DATA_DICT_API: '/maindata/dictData/listDataDict',
  /**添加字典数据 */
  ADD_DICT_DATA_API: '/maindata/dictData/insertDataDict',
  /**获取字典数据详情 */
  GET_DICT_DATA_API: '/maindata/dictData/getDictDataDetail',
  /**编辑字典数据详情 */
  UPDATE_DICT_DATA_API: '/maindata/dictData/updateDictData',
  /**删除字典数据 */
  DELETE_DICT_DATA_API: '/maindata/dictData/deleteDataDict',
  //获取全部字典 对象形式
  GET_ALLDICT_MAP: '/maindata/dict/getAllDictForMap',
  //刷新费用类型缓存
  RE_EXPENSETYPE: '/maindata/sysExpenseType/refreshSysExpenseType',
};
